import { css } from '@emotion/react';
import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '../../Styles';
import { Button } from '../../Widgets';

const CONTAINER_STYLE = css`
  label: NOT_FOUND_CONTAINER;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: ${LAYOUT2.spacing2}px;
`;

const TITLE_STYLE = css`
  label: NOT_FOUND_TITLE;
  ${TYPOGRAPHY2.xxxLargeBold}
  color: ${COLORS2.namedColors.darkYellow};
`;

const SUBTITLE_STYLE = css`
  label: NOT_FOUND_SUBTITLE;
  ${TYPOGRAPHY2.large}
  color: var(--text2);
`;

const BODY_STYLE = css`
  label: NOT_FOUND_BODY;
  ${TYPOGRAPHY2.medium}
  color: var(--text2);
  margin-bottom: ${LAYOUT2.spacing2}px;
`;

export const NotFoundPage = () => (
  <div css={CONTAINER_STYLE}>
    <div css={TITLE_STYLE}>404</div>
    <div css={SUBTITLE_STYLE}>Page Not Found</div>
    <div css={BODY_STYLE}>
      The page you're looking for doesn't exist or has been moved.
    </div>
    <Button href='/'>Return Home</Button>
  </div>
);
